import { ResourcesConfig } from "aws-amplify";
import {
  VITE_APPSYNC_APIKEY,
  VITE_APPSYNC_ENDPOINT,
  VITE_APPSYNC_REGION,
  VITE_OAUTH_DOMAIN,
  VITE_URL,
  VITE_USER_POOL_ID,
  VITE_USER_POOL_WEB_CLIENT_ID,
} from "./config";

export const amplifyConfig: ResourcesConfig = {
  API: {
    Events: {
      apiKey: VITE_APPSYNC_APIKEY,
      endpoint: VITE_APPSYNC_ENDPOINT,
      region: VITE_APPSYNC_REGION,
      defaultAuthMode: "apiKey",
    },
  },
  Auth: {
    Cognito: {
      userPoolId: `${VITE_USER_POOL_ID}`,
      userPoolClientId: VITE_USER_POOL_WEB_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: VITE_OAUTH_DOMAIN,
          scopes: ["phone", "email", "openid", "aws.cognito.signin.user.admin"],
          redirectSignIn: [VITE_URL],
          redirectSignOut: [VITE_URL],
          responseType: "code", // or 'token', note that REFRESH token will only be generated when the responseType is code
          providers: ["Google"],
        },
      },
    },
  },
};
